export default [
  {
    path: "/call-dashboard",
    component: () => import("@/modules/Sales/pages/SalesMain/UI/SalesMain.vue"),
    name: "call-main",
    meta: {
      layout: "main",
      auth: true,
      role: ["call"],
    },
  },
];
